<template>
  <div class="banner">
    <div class="swiper-container swiper1">
      <div class="swiper-wrapper">
        <div v-for="item in swiperItems" :key="item.aid" class="swiper-slide">
          <img :src="item.imgSrc" class="img" />
        </div>
        <!--
        <div class="swiper-slide">
          <img src="http://image.qmango.com/hotelimg/dl1210/119297/793.jpeg" class="img" />
        </div>
        -->
      </div>
      <div class="swiper-pagination">
        <span v-for="(item, index) in swiperItems" :key="item.aid" class="swiper-pagination-bullet" :class="{'swiper-pagination-bullet-active': index === 0}"></span>
        <!-- <span class="swiper-pagination-bullet swiper-pagination-bullet-active"></span> -->
        <!--
        <span class="swiper-pagination-bullet"></span>
        -->
      </div>
    </div>
    <!-- /swiper -->

    <div class="status-info" v-if="showData">
      <div class="status-info__container">
        <dl v-for="stats in pagebarstats" :key="stats.sid" class="stat-dl stat-dl1">
          <dt class="fs16 stat-dt">{{stats.keyName}}</dt>
          <dd class="fs30 stat-dd">{{stats.value}}</dd>
        </dl>
        <!--
        <dl class="stat-dl stat-dl1">
          <dt class="fs16 stat-dt">注册用户</dt>
          <dd class="fs30 stat-dd">15,628</dd>
        </dl>
        -->
      </div>
    </div>
  </div>
  <!-- /banner -->
</template>

<script>
import Swiper from 'swiper';
import config from '@/config/index';

import {
  queryAdvertises,
  queryPagebarstat
} from '@/api/main';

export default {
  name: 'Banner',
  props: {
    msg: String,
    showData:Boolean
  },
  data() {
    return {
      swiperItems: [],
      pagebarstats: []
    }
  },
  mounted() {
    // eslint-disable-next-line no-new
    this._queryAdvertises();
    this._queryPagebarstat();
  },
  methods: {
    formatData(list = []) {
      list.forEach(element => {
        element.imgSrc = `${config.HOST_IMG}/${element.img}`;
        return element;
      });
      return list;
    },
    formatStatsData(list = []) {
      list.forEach(element => {
        element.value = parseInt(element.value).toLocaleString();
        return element;
      });
      return list;
    },
    _queryPagebarstat() {
      this.$http.get(queryPagebarstat()).then((res) => {
        this.pagebarstats = this.formatStatsData(res.data);
      });
    },
    _queryAdvertises() {
      this.$http.get(queryAdvertises()).then((res) => {
        this.swiperItems = this.formatData(res.data);
        new Swiper('.swiper1', {
          initialSlide :0,
          observer:true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true, //修改swiper的父元素时，自动初始化swiper
          loop: true,
          pagination: {
            el: '.swiper-pagination',
          },
        });
      });
    }
  }
};
</script>

<style>
@import url(./Banner.css);
</style>
